var MathHelper = (function () {
    function MathHelper() {
    }
    MathHelper.randomFrom = function (from, to) {
        return Math.floor(Math.random() * (to - from + 1) + from);
    };
    MathHelper.randomFromArray = function (array) {
        return array[Math.floor(Math.random() * array.length)];
    };
    MathHelper.popRandom = function (array) {
        return array.splice(Math.floor(Math.random() * array.length), 1)[0];
    };
    MathHelper.toFixedNumber = function (value, fixedTo) {
        if (fixedTo === void 0) { fixedTo = 2; }
        return Number(value.toFixed(fixedTo));
    };
    MathHelper.getDistance = function (pos1, pos2) {
        var dx = pos1.x - pos2.x;
        var dy = pos1.y - pos2.y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    MathHelper.getVelocity = function (from, to, speed) {
        var dx = to.x - from.x;
        var dy = to.y - from.y;
        var distance = Math.sqrt(dx * dx + dy * dy);
        return { x: dx / distance * speed, y: dy / distance * speed };
    };
    MathHelper.getAngleBetweenTwoPoints = function (origin, pA, pB) {
        return Phaser.Math.RadToDeg(Math.atan2(pB.y - origin.y, pB.x - origin.x) -
            Math.atan2(pA.y - origin.y, pA.x - origin.x));
    };
    MathHelper.getPositionFromDistanceAndAngle = function (origin, distance, angle) {
        return {
            x: origin.x + distance * Math.cos(Phaser.Math.DegToRad(angle)),
            y: origin.y + distance * Math.sin(Phaser.Math.DegToRad(angle)),
        };
    };
    MathHelper.circleRectangleCollision = function (circleCenter, radius, rectangleCenter, rectangleDimensions) {
        var testX = circleCenter.x;
        var testY = circleCenter.y;
        if (circleCenter.x < rectangleCenter.x - rectangleDimensions.x * 0.5) {
            testX = rectangleCenter.x - rectangleDimensions.x * 0.5;
        }
        else if (circleCenter.x > rectangleCenter.x + rectangleDimensions.x * 0.5) {
            testX = rectangleCenter.x + rectangleDimensions.x * 0.5;
        }
        if (circleCenter.y < rectangleCenter.y - rectangleDimensions.y * 0.5) {
            testY = rectangleCenter.y - rectangleDimensions.y * 0.5;
        }
        else if (circleCenter.y > rectangleCenter.y + rectangleDimensions.y * 0.5) {
            testY = rectangleCenter.y + rectangleDimensions.y * 0.5;
        }
        var distX = circleCenter.x - testX;
        var distY = circleCenter.y - testY;
        var distance = Math.sqrt((distX * distX) + (distY * distY));
        if (distance <= radius) {
            return true;
        }
        return false;
    };
    MathHelper.sum = function (array) {
        if (array.length === 0) {
            return 0;
        }
        return array.reduce(function (prev, current) {
            return prev + current;
        });
    };
    MathHelper.isBetween = function (value, from, to) {
        if (value < from) {
            return false;
        }
        if (value > to) {
            return false;
        }
        return true;
    };
    MathHelper.getValueIfInRange = function (min, value, max) {
        return value < min ? min : value > max ? max : value;
    };
    MathHelper.multiplyPoint = function (p, m) {
        return {
            x: p.x * m,
            y: p.y * m,
        };
    };
    return MathHelper;
}());
export { MathHelper };
